import { Modal } from 'components/UI/Modal';
import { Typography } from 'components/UI/Typography';
import { toast } from 'react-toastify';
import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

type DetachMutation = {
	mutateAsync: () => Promise<unknown>;
	isLoading: boolean;
};

export function ConfirmDetachCodelistModal({
	open,
	onClose,
	detachMutation
}: {
	open: boolean;
	onClose: () => void;
	detachMutation: DetachMutation;
}) {
	const language = useLanguage();
	const translation = DICTIONARY[language];
	async function onConfirm() {
		try {
			await detachMutation.mutateAsync();
			onClose();
		} catch (error) {
			console.error(translation.error, error);
			toast.error(translation.error);
		}
	}

	return (
		<Modal
			visible={open}
			title={translation.title}
			primary={{
				label: translation.delete,
				loading: detachMutation.isLoading,
				warning: true,
				onClick: onConfirm
			}}
			neutral={{
				label: translation.cancel,
				onClick: onClose
			}}
			onClose={onClose}
			size={s => s.s}
			enterAsPrimaryOnClick
			close
		>
			<Typography.Paragraph>{translation.description}</Typography.Paragraph>
		</Modal>
	);
}

const DICTIONARY = {
	[LanguageType.English]: {
		title: 'Remove codelist record?',
		description: 'Are you sure you want to remove the codelist record from this entry?',
		delete: 'Delete',
		cancel: 'Cancel',
		error: 'An error occurred while removing codelist'
	},
	[LanguageType.Norwegian]: {
		title: 'Fjern kodelisteraden?',
		description: 'Er du sikker på at du vil fjerne kodelisteraden fra denne oppføringen?',
		delete: 'Slett',
		cancel: 'Avbryt',
		error: 'En feil oppstod ved fjerning av kodeliste'
	}
} as const;
